import { render, staticRenderFns } from "./TicketsManagement.vue?vue&type=template&id=dcc00962"
import script from "./TicketsManagement.vue?vue&type=script&lang=js"
export * from "./TicketsManagement.vue?vue&type=script&lang=js"
import style0 from "./TicketsManagement.vue?vue&type=style&index=0&id=dcc00962&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports